import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { PoModalComponent, PoModule, PoNotificationService } from '@po-ui/ng-components';
import { AppService } from '../../services/app.service';
import { Router } from '@angular/router';
import { AuthenticationModel } from '../../models/authentication.model';
import { AuthService } from '../../services/auth.service';
import { ApiService } from '../../services/api.service';
import { clearSessionData } from '../../utils/clearSessionData.util';
import { TenantService } from '../../services/tenant.service';

@Component({
  standalone: true,
  imports: [PoModule, FormsModule],
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  @ViewChild('modalForm') form!: NgForm;
  @ViewChild('modal') modal!: PoModalComponent;

  errorPattern: string = 'A senha deve conter letras maiúscula, minúscula, número, caractere especial (@$!%*?&+-) e no mínimo 6 dígitos.';
  event: string = '';
  minlength: number = 6;
  password: string = '';
  confirmPassword: string = '';
  autenticationCode: string = '';
  pattern: string = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&+-]).{6,}$';

  placeholders = {
    cpfCnpj: 'Informe seu CPF/CNPJ',
    password: 'Informe sua senha',
    confirmPassword: 'Confirme sua senha',
    email: 'Informe seu email',
  };

  labels = {
    cpfCnpj: 'CPF/CNPJ',
    email: 'Email',
    password: 'Senha',
    confirmPassword: 'Confirmar senha',
  };

  tenant: string | null = '';
  cpfCnpj: string = '';
  email: string = '';
  isRequired: boolean = true;
  showRequired: boolean = true;

  constructor(
    private appService: AppService,
    private router: Router,
    private authService: AuthService,
    private poNotification: PoNotificationService,
    private apiService: ApiService,
    private tenantService: TenantService
  ) {

  }

  ngOnInit() {
    if (this.form) {
      this.form.resetForm();
    }

    this.tenant = this.tenantService.getTenant();
    if (!this.tenant) {
      this.router.navigate(['/login']);
    }

    this.restore();
  }

  changeEvent(event: string) {
    this.event = event;
  }

  theme = 'assets/login_ThemeDefault.png';

  async onBackLogin() {
    clearSessionData();
    this.router.navigate(['/login'], { queryParams: { tenant: this.tenantService.getTenant() } });
  }

  async onResetPassword() {
    this.clearModalFields();

    if (this.form) {
      this.form.resetForm();
    }

    const authenticationModel: AuthenticationModel = {    
      tenant: this.tenantService.getTenant() || '',
      cpfCnpj: this.cpfCnpj.replace(/\D/g, ''),
      password: this.password,
      email: this.email,
      product: 703
    };

    let authenticationResult = await this.authService.authenticationRecovery(authenticationModel);

    if(!authenticationResult.isAuthenticated) {
      return;
    }
    
    this.modal.open();
    await this.customerGenerateCode();
  }

  closeModal() {
    this.clearModalFields();
    this.modal.close();
  }

  isCodeValid(): boolean {
    const isCodeValid = !!this.autenticationCode && this.autenticationCode.length === 6
    return isCodeValid;
  }

  async customerGenerateCode(): Promise<boolean> {
    await this.apiService.setterHeader('PTCAPP003');
    const body = {
        cpfCnpj: this.cpfCnpj.replace(/\D/g, ''),
        email: this.email
    };

    return new Promise((resolve, reject) => {
      this.apiService.postCustomerGenerateCode(body).subscribe(
        response => {
          resolve(true);
        },
        error => {
          if (error.error && Array.isArray(error.error) && error.error.length > 0) {
            const errorMessage = error.error[0].message || 'Erro desconhecido.';
            this.poNotification.error(errorMessage);
          } else if (error.message) {
            this.poNotification.error(error.message);
          } else {
            this.poNotification.error('Ocorreu um erro ao gerar o código de ativação.');
          }
          reject(false);
        }
      );
    });
  }

  isFormValid(): boolean {
    const isPasswordValid = !!this.password && !!this.confirmPassword && this.password === this.confirmPassword;
    const isPasswordPattern = new RegExp(this.pattern).test(this.password);
    const isConfirmPasswordPattern = new RegExp(this.pattern).test(this.confirmPassword);
    const isAutenticationCodeFilled = !!this.autenticationCode && this.autenticationCode.length === 6;

    return isAutenticationCodeFilled && isPasswordValid && isPasswordPattern && isConfirmPasswordPattern;
  }

  async confirmNewPassword() {

    const isActivateCodeValid = await this.customerGeneratePassword();

    if(isActivateCodeValid) {
      this.poNotification.success('Troca de senha efetuada com sucesso!');
      this.clearModalFields();
      this.modal.close();
      clearSessionData();
      setTimeout(() => {
        this.router.navigate(['/login'], { queryParams: { tenant: this.tenant } });
      }, 2000); 
    } else {
      this.poNotification.warning('Código informado inválido!');
    }
  }

  async customerGeneratePassword(): Promise<boolean> {
    await this.apiService.setterHeader('PTCAPP003');
    const body = {
        cpfCnpj: this.cpfCnpj.replace(/\D/g, ''),
        autenticationCode: this.autenticationCode,
        password: this.password
    };

    return new Promise((resolve, reject) => {
      this.apiService.postCustomerGeneratePassword(body).subscribe(
        response => {
          //qual o retorno???
          resolve(true);
        },
        error => {
          if (error.error && Array.isArray(error.error) && error.error.length > 0) {
            const errorMessage = error.error[0].message || 'Erro desconhecido.';
            this.poNotification.error(errorMessage);
          } else {
            this.poNotification.error('Ocorreu um erro ao gerar a alteração de senha.');
          }
  
          reject(false);
        }
      );
    });
  }

  restore() {
    this.cpfCnpj = '';
    this.password = '';
    this.showRequired = true;
    this.theme = this.appService.loginTheme ?? this.theme;
  }

  clearModalFields() {
    this.autenticationCode = '';
    this.password = '';
    this.confirmPassword = '';
  }

}
